import type { WorkflowEvent } from '../hooks/useWorkflowEvents';

/** Build the workflow preview link for an immutable definition revision. */
export function workflowEventRevisionHref(event: WorkflowEvent): string | null {
  const revisionNumber = event.metadata?.revisionNumber;
  if (
    event.eventType !== 'definition_changed' ||
    !event.revisionId ||
    typeof revisionNumber !== 'number' ||
    !Number.isInteger(revisionNumber) ||
    revisionNumber <= 0
  ) {
    return null;
  }
  return `/flows/${event.workflowId}?revision=${revisionNumber}`;
}
